var _rect, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHero(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 1200,
    width: 1600,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#effaff",
    width: 1600,
    height: 1200
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1163.53 103.83H1136.76V130.59H1163.53V103.83Z",
    fill: "#78c7e0",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M908.51 119.85H1155.69L1163.53 130.59V322.67H903.84V130.59L908.51 119.85Z",
    fill: "#3d84a8",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1046.1 103.83H903.84V130.59H1163.53V103.83H1092.49",
    fill: "#78c7e0",
    opacity: 1,
    strokeWidth: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1046.1 103.83H903.84V130.59H1163.53V103.83H1092.49",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1083.24 103.83H1056.48",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1124.13 219.5C1109.54 183.8 1074.35 158.69 1033.3 158.69 1000.34 158.69 971.28 174.88 953.49 199.74L945.4 213.25C945.4 213.38 945.27 213.51 945.27 213.63 935.45 233.52 950.3 256.79 972.49 256.79H1063C1060.2 256.79 1057.71 258.77 1057.46 261.57 1057.2 264.76 1059.69 267.43 1062.75 267.43H1074.99C1074.99 267.43 1075.12 267.56 1074.99 267.56 1072.31 268.07 1070.46 270.49 1070.72 273.3 1070.97 276.1 1073.52 278.08 1076.26 278.08H1090.1L1104.44 295.61C1105.52 296.95 1107.24 297.71 1108.96 297.71 1113.36 297.71 1116.1 293.19 1114.25 289.24L1098.83 256.85C1118.14 256.79 1131.4 237.28 1124.13 219.5Z",
    fill: "#abedd8",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1016.41 204.9V194.64H1048.53V226.77H1016.41V208.85",
    fill: "#78c7e0",
    opacity: 1,
    strokeWidth: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1016.41 204.9V194.64H1048.53V226.77H1016.41V208.85",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1032.47 226.77V237.79",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1016.41 245.89C1018.17 245.89 1019.59 244.46 1019.59 242.7 1019.59 240.94 1018.17 239.51 1016.41 239.51 1014.64 239.51 1013.22 240.94 1013.22 242.7 1013.22 244.46 1014.64 245.89 1016.41 245.89Z",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1041.52 246.02C1039.8 246.02 1038.33 244.55 1038.33 242.83 1038.33 241.11 1039.8 239.64 1041.52 239.64 1043.24 239.64 1044.71 241.11 1044.71 242.83 1044.71 243.59 1044.45 244.3 1043.94 244.81",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1057.46 184.44C1059.22 184.44 1060.65 183.01 1060.65 181.25 1060.65 179.49 1059.22 178.07 1057.46 178.07 1055.69 178.07 1054.27 179.49 1054.27 181.25 1054.27 183.01 1055.69 184.44 1057.46 184.44Z",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1023.86 181.25C1025.62 181.25 1027.05 179.82 1027.05 178.07 1027.05 176.31 1025.62 174.88 1023.86 174.88 1022.11 174.88 1020.68 176.31 1020.68 178.07 1020.68 179.82 1022.11 181.25 1023.86 181.25Z",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1018.57 240.22L1023.48 235.44V226.77",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M998.62 221.6C1000.38 221.6 1001.81 220.17 1001.81 218.42 1001.81 216.66 1000.38 215.23 998.62 215.23 996.86 215.23 995.43 216.66 995.43 218.42 995.43 220.17 996.86 221.6 998.62 221.6Z",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M998.62 206.24C1000.38 206.24 1001.81 204.81 1001.81 203.05 1001.81 201.29 1000.38 199.87 998.62 199.87 996.86 199.87 995.43 201.29 995.43 203.05 995.43 204.81 996.86 206.24 998.62 206.24Z",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1001.81 218.42H1016.41",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1001.81 203.05H1016.41",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1066.38 206.24C1068.14 206.24 1069.57 204.81 1069.57 203.05 1069.57 201.29 1068.14 199.87 1066.38 199.87 1064.62 199.87 1063.2 201.29 1063.2 203.05 1063.2 204.81 1064.62 206.24 1066.38 206.24Z",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1066.38 221.6C1068.14 221.6 1069.57 220.17 1069.57 218.42 1069.57 216.66 1068.14 215.23 1066.38 215.23 1064.62 215.23 1063.2 216.66 1063.2 218.42 1063.2 220.17 1064.62 221.6 1066.38 221.6Z",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1063.2 203.05H1048.53",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1063.2 218.42H1048.53",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1041.52 226.77V239.77",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1041.52 194.64V181.25H1054.14",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1023.86 194.64V181.25",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1032.47 194.64V185.08",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1075.75 256.79H1084.68",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1063 256.79H1071.16",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1082.57 267.43H1074.99",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1098.89 256.79H1092.65",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M500.17 123.3H428.2V336.37H709.8V123.3L522.91 123.3",
    fill: "#3d84a8",
    opacity: 1,
    strokeWidth: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.17 123.3H428.2V336.37H709.8V123.3L522.91 123.3",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.86 138.41H474.44V166.99H445.86V138.41Z",
    fill: "#48466d",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.44 182.55L445.86 182.55",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.44 195.12H445.86",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.44 207.69H445.86",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M546.54 181.14V176.75H610.23V189.93C610.23 203.72 582.79 224.52 582.79 230.82 582.79 238.54 610.23 258.26 610.23 271.81V285H546.54V271.81C546.54 258.31 573.98 238.56 573.98 230.82 573.98 224.52 546.54 203.72 546.54 189.93V185.49",
    fill: "#abedd8",
    opacity: 1,
    strokeWidth: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.54 181.14V176.75H610.23V189.93C610.23 203.72 582.79 224.52 582.79 230.82 582.79 238.54 610.23 258.26 610.23 271.81V285H546.54V271.81C546.54 258.31 573.98 238.56 573.98 230.82 573.98 224.52 546.54 203.72 546.54 189.93V185.49",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.77 289.51H616.12",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.62 172.16H612.89V177.94H543.9V172.16H600.86",
    fill: "#abedd8",
    opacity: 1,
    strokeWidth: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.62 172.16H612.89V177.94H543.9V172.16H600.86",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.87 283.73H543.9V289.51H612.87V283.73Z",
    fill: "#abedd8",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.05 206.95C564.83 206.95 563.58 209.53 564.97 211.24 570.15 217.76 578.42 227.31 578.42 227.31 578.42 227.31 586.7 217.79 591.88 211.24 593.27 209.49 592.02 206.95 589.8 206.95H567.05Z",
    fill: "#48466d",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.37 227.31V243.08",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.37 247.11V254.41",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.37 258.75V262",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M947.4 278.99V407.74H652.6V221.86L661.88 205.17H933.09L947.4 221.86V261.74",
    fill: "#78c7e0",
    opacity: 1,
    strokeWidth: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M947.4 278.99V407.74H652.6V221.86L661.88 205.17H933.09L947.4 221.86V261.74",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M910.25 188.33H652.6V221.86H910.25V188.33Z",
    fill: "#46cdcf",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M947.4 188.33H910.4V221.86H947.4V188.33Z",
    fill: "#46cdcf",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M673 237.87H703.61",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M673 253.19H703.61",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M673 268.51H703.61",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M800 407.74V505.16",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1064.82 668.83H1047.98V698.72H1064.82V668.83Z",
    fill: "#78c7e0",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1105.94 780.4H937.53V1044.38H1105.94V780.4Z",
    fill: "#3d84a8",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1105.94 696.47H937.53V780.68H1105.94V696.47Z",
    fill: "#3d84a8",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1079.98 908.95H963.49V977.02H1079.98V908.95Z",
    fill: "#78c7e0",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1058.79 949.51C1062.43 949.51 1065.38 946.56 1065.38 942.92 1065.38 939.27 1062.43 936.32 1058.79 936.32 1055.14 936.32 1052.19 939.27 1052.19 942.92 1052.19 946.56 1055.14 949.51 1058.79 949.51Z",
    fill: "#ffffff",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1079.98 804.96H1030.86V893.51H1079.98V804.96Z",
    fill: "#48466d",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1012.75 840.89H996.05V893.51H1012.75V840.89Z",
    fill: "#48466d",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M971.63 893.51C976.21 893.51 979.91 889.81 979.91 885.23 979.91 880.66 976.21 876.95 971.63 876.95 967.06 876.95 963.35 880.66 963.35 885.23 963.35 889.81 967.06 893.51 971.63 893.51Z",
    fill: "#78c7e0",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M971.63 857.45C976.21 857.45 979.91 853.74 979.91 849.17 979.91 844.59 976.21 840.89 971.63 840.89 967.06 840.89 963.35 844.59 963.35 849.17 963.35 853.74 967.06 857.45 971.63 857.45Z",
    fill: "#78c7e0",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M971.63 821.52C976.21 821.52 979.91 817.81 979.91 813.24 979.91 808.66 976.21 804.96 971.63 804.96 967.06 804.96 963.35 808.66 963.35 813.24 963.35 817.81 967.06 821.52 971.63 821.52Z",
    fill: "#78c7e0",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1004.33 821.52C1008.91 821.52 1012.61 817.81 1012.61 813.24 1012.61 808.66 1008.91 804.96 1004.33 804.96 999.76 804.96 996.05 808.66 996.05 813.24 996.05 817.81 999.76 821.52 1004.33 821.52Z",
    fill: "#48466d",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1048.26 762.15H1064.82",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1048.26 747.14H1064.82",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1048.26 732.54H1064.82",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1048.26 717.81H1064.82",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M976.55 711.91H967V763.98H976.55V711.91Z",
    fill: "#ffffff",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1004.19 711.91H994.65V763.98H1004.19V711.91Z",
    fill: "#ffffff",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M960.83 733.95H982.58",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M988.47 757.52H1010.23",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1095.27 646.09H1017.67V670.37H1095.27V646.09Z",
    fill: "#78c7e0",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M940.31 443.93H659.96V479.88H940.31V443.93Z",
    fill: "#abedd8",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.96 747.01V1018.94H940.18V498.86H659.96V673.38",
    fill: "#46cdcf",
    opacity: 1,
    strokeWidth: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.96 747.01V1018.94H940.18V498.86H659.96V673.38",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.96 689.95V732.57",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M969.84 474.67H630.16V505.4H969.84V474.67Z",
    fill: "#abedd8",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M800 834.4C841.33 834.4 874.83 800.9 874.83 759.57 874.83 718.24 841.33 684.73 800 684.73 758.67 684.73 725.17 718.24 725.17 759.57 725.17 800.9 758.67 834.4 800 834.4Z",
    fill: "#ffffff",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M817.64 738.45V768.92",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M817.64 768.92C817.64 775.47 812.56 780.55 806.01 780.55 799.47 780.55 794.39 775.47 794.39 768.92",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M741.47 1013.33V926.47",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M764.72 1013.33V908.57L728.24 871.95",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M788.37 1013.33V866.34",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M811.63 1013.33V945.05",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M835.14 1013.33V904.29L869.62 869.81",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M858.66 1013.33V926.47",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M741.47 926.34C744.78 926.34 747.48 923.65 747.48 920.33 747.48 917.01 744.78 914.31 741.47 914.31 738.14 914.31 735.46 917.01 735.46 920.33 735.46 923.65 738.14 926.34 741.47 926.34Z",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M723.96 873.55C727.29 873.55 729.98 870.87 729.98 867.54 729.98 864.23 727.29 861.53 723.96 861.53 720.64 861.53 717.95 864.23 717.95 867.54 717.95 870.87 720.64 873.55 723.96 873.55Z",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M811.63 945.05C814.94 945.05 817.64 942.36 817.64 939.03 817.64 935.72 814.94 933.02 811.63 933.02 808.3 933.02 805.61 935.72 805.61 939.03 805.61 942.36 808.3 945.05 811.63 945.05Z",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M788.37 866.47C791.7 866.47 794.39 863.79 794.39 860.46 794.39 857.14 791.7 854.45 788.37 854.45 785.05 854.45 782.36 857.14 782.36 860.46 782.36 863.79 785.05 866.47 788.37 866.47Z",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M858.66 926.34C861.98 926.34 864.68 923.65 864.68 920.33 864.68 917.01 861.98 914.31 858.66 914.31 855.34 914.31 852.65 917.01 852.65 920.33 852.65 923.65 855.34 926.34 858.66 926.34Z",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M874.03 871.68C877.35 871.68 880.04 869 880.04 865.67 880.04 862.34 877.35 859.66 874.03 859.66 870.7 859.66 868.02 862.34 868.02 865.67 868.02 869 870.7 871.68 874.03 871.68Z",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M741.47 505.67V591.19H703.79",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M764.72 505.67V610.44",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M788.37 505.67V643.31",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M811.63 505.67V573.96",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M835.14 505.67V614.71L869.62 649.19",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M858.66 505.67V597.21H881.25",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M697.64 597.21C700.95 597.21 703.65 594.52 703.65 591.19 703.65 587.88 700.95 585.18 697.64 585.18 694.31 585.18 691.63 587.88 691.63 591.19 691.63 594.52 694.31 597.21 697.64 597.21Z",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M764.72 622.33C768.05 622.33 770.73 619.64 770.73 616.32 770.73 613 768.05 610.3 764.72 610.3 761.39 610.3 758.71 613 758.71 616.32 758.71 619.64 761.39 622.33 764.72 622.33Z",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M811.63 585.98C814.94 585.98 817.64 583.3 817.64 579.97 817.64 576.64 814.94 573.96 811.63 573.96 808.3 573.96 805.61 576.64 805.61 579.97 805.61 583.3 808.3 585.98 811.63 585.98Z",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M788.37 655.47C791.7 655.47 794.39 652.78 794.39 649.46 794.39 646.13 791.7 643.44 788.37 643.44 785.05 643.44 782.36 646.13 782.36 649.46 782.36 652.78 785.05 655.47 788.37 655.47Z",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M887.39 603.22C890.71 603.22 893.41 600.53 893.41 597.21 893.41 593.89 890.71 591.19 887.39 591.19 884.07 591.19 881.38 593.89 881.38 597.21 881.38 600.53 884.07 603.22 887.39 603.22Z",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M874.03 659.35C877.35 659.35 880.04 656.66 880.04 653.33 880.04 650.02 877.35 647.32 874.03 647.32 870.7 647.32 868.02 650.02 868.02 653.33 868.02 656.66 870.7 659.35 874.03 659.35Z",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M969.84 1013.33H630.16V1044.07H969.84V1013.33Z",
    fill: "#abedd8",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1124 694.16V760.5H1282.4V708.48 669.33H1124V694.16Z",
    fill: "#ffffff",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1127.14 681.3C1127.14 696.51 1139.33 708.7 1154.54 708.7H1260.92C1285.53 708.7 1305.67 688.79 1305.67 663.96V620.67C1305.67 580.06 1272.78 547.17 1232.18 547.17H1198.51 1156.33C1132.51 547.17 1113.04 566.53 1113.04 590.46V617.87 636.22L1095.93 639.8 1023.78 654.79 1039.77 701.88 1113.15 684.32 1127.14 681.3Z",
    fill: "#ffffff",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1124 747.97H1282.4V1044.29H1124V747.97Z",
    fill: "#48466d",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1128.93 690.58L1115.5 690.81 1086.98 617.87H1190.79L1208.01 661.83 1219.42 690.81 1128.93 690.58Z",
    fill: "#3d84a8",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1201.64 498.07C1179.04 498.07 1160.14 506.23 1155.44 527.37 1154.65 530.73 1154.32 534.09 1154.32 537.66 1154.32 563.73 1175.46 584.98 1201.64 584.98 1218.19 584.98 1233.18 576.03 1241.68 563.06 1246.61 555.67 1243.59 547.17 1243.59 537.66 1243.59 511.6 1227.81 498.07 1201.64 498.07Z",
    fill: "#ffffff",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1201.64 490.57C1227.59 490.57 1248.96 511.6 1248.96 537.89 1248.96 547.17 1246.16 555.79 1241.68 563.06 1232.62 563.06 1225.35 555.79 1225.35 546.73V527.26H1155.55C1160.25 505.9 1179.15 490.57 1201.64 490.57Z",
    fill: "#48466d",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1179.38 541.47V555.79",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1179.38 555.79C1179.38 559.37 1182.17 562.05 1185.64 562.05 1189.22 562.05 1191.91 559.25 1191.91 555.79",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1203.2 1044.29V830.63",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1203.2 819.78V800.1",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1305.45 641.14V663.96C1305.45 688.57 1285.53 708.7 1260.7 708.7H1154.32C1139.11 708.7 1126.91 696.51 1126.91 681.3V672.24 661.83H1234.86L1255.89 661.61C1246.05 661.61 1238.1 653.78 1238.1 643.82",
    fill: "#ffffff",
    opacity: 1,
    strokeWidth: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1305.45 641.14V663.96C1305.45 688.57 1285.53 708.7 1260.7 708.7H1154.32C1139.11 708.7 1126.91 696.51 1126.91 681.3V672.24 661.83H1234.86L1255.89 661.61C1246.05 661.61 1238.1 653.78 1238.1 643.82",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M800 835.34C842.16 835.34 876.34 801.16 876.34 759 876.34 716.84 842.16 682.66 800 682.66 757.83 682.66 723.66 716.84 723.66 759 723.66 801.16 757.83 835.34 800 835.34Z",
    fill: "#abedd8",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M817.65 715.45H779.15V730.19H817.65V715.45Z",
    fill: "#46cdcf",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M817.65 730.19H779.15V744.94H817.65V730.19Z",
    fill: "#78c7e0",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M790.59 776.07H752.08V790.82H790.59V776.07Z",
    fill: "#46cdcf",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M848.11 776.07H809.6V790.82H848.11V776.07Z",
    fill: "#78c7e0",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M798.55 745.03L773.03 770.54",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M798.55 745.03L824.06 770.54",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1125.04 1044.15L1437.01 1044.15",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.99 1044.15L1057.69 1044.15",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M417.83 573.67C436.94 573.67 453.26 575 460.7 591.2 463.35 597.18 465.08 604.08 465.08 611.12 465.08 637.15 443.97 658.4 417.83 658.4 391.81 658.4 370.57 637.29 370.57 611.12 370.57 585.09 391.68 573.67 417.83 573.67Z",
    fill: "#ffffff",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.83 563.71C436.81 563.71 453.26 575 460.7 591.33H435.21V640.61H381.06C374.56 632.51 370.71 622.15 370.71 610.99 370.57 584.96 391.68 563.71 417.83 563.71Z",
    fill: "#48466d",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.82 885.38H518.7V1043.95H595.82V885.38Z",
    fill: "#48466d",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.77 842.35V794.93 789.35H531.44 668.15C667.89 762 645.72 740.08 618.38 740.08H546.44L518.7 676.2C509.01 653.49 486.71 638.88 462.29 638.88H371.77C348.81 638.88 330.09 657.34 330.09 680.58V842.88L502.77 842.35Z",
    fill: "#ffffff",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.77 710.33V730.92",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.77 739.68V789.09",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M748.99 1044.22L670.28 886.97C655.41 857.75 625.55 839.29 593.03 839.29H569.14 330.08V842.48C330.36 877.01 358.36 905.03 392.87 905.03H602.58L672 1044.22H748.99Z",
    fill: "#48466d",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.19 905.03H622.89",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M398.8 691.41H260.87L347.41 914.57H485.47L398.8 691.41Z",
    fill: "#3d84a8",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.08 924.47H343.71V904.92H536.08C541.63 904.92 545.99 909.28 545.99 914.83 545.99 920.11 541.63 924.47 536.08 924.47Z",
    fill: "#3d84a8",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.01 924.47V1043.39",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.94 924.47V1043.39",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M389.56 382.7H261.26V515.34H389.56V382.7Z",
    fill: "#78c7e0",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.17 515.34V538.32C325.17 551.06 335.4 561.3 348.15 561.3",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M839.83 249.19H775.75V350.11H839.83V249.19Z",
    fill: "#abedd8",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M853.54 258.15H793.25V359.08H853.54V258.15Z",
    fill: "#48466d",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M849.04 264.6C849.04 265.2 848.83 265.73 848.44 266.12 847.98 266.66 847.31 266.97 846.6 266.97 845.29 266.97 844.23 265.91 844.23 264.6 844.23 263.29 845.29 262.23 846.6 262.23 847.91 262.23 849.04 263.29 849.04 264.6Z",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M800.94 266.97C802.25 266.97 803.31 265.91 803.31 264.6 803.31 263.29 802.25 262.23 800.94 262.23 799.63 262.23 798.57 263.29 798.57 264.6 798.57 265.91 799.63 266.97 800.94 266.97Z",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M828.5 271.05H746.46V371.12H828.5V271.05Z",
    fill: "#3d84a8",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M845.61 377V281.11H762.96V376.97C765.94 376.97 765.94 378.81 768.81 378.81 771.78 378.81 771.78 376.97 774.73 376.97 777.7 376.97 777.7 378.81 780.64 378.81 783.62 378.81 783.62 376.97 786.56 376.97 789.5 376.97 789.53 378.81 792.47 378.81 795.45 378.81 795.45 376.97 798.39 376.97 801.33 376.97 801.36 378.81 804.3 378.81 807.28 378.81 807.28 376.97 810.22 376.97 813.16 376.97 813.2 378.81 816.14 378.81 819.08 378.81 819.11 376.97 822.05 376.97 825.03 376.97 825.03 378.81 827.97 378.81 830.91 378.81 830.94 376.97 833.88 376.97 836.82 376.97 836.86 378.81 839.8 378.81 842.67 378.84 842.67 377 845.61 377Z",
    fill: "#abedd8",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M804.3 292.44C805.61 292.44 806.68 291.38 806.68 290.07 806.68 288.76 805.61 287.7 804.3 287.7 802.99 287.7 801.93 288.76 801.93 290.07 801.93 291.38 802.99 292.44 804.3 292.44Z",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M757.26 277.74C757.33 277.96 757.33 278.13 757.33 278.35 757.33 279.66 756.27 280.72 754.96 280.72 753.65 280.72 752.59 279.66 752.59 278.35 752.59 277.03 753.65 275.97 754.96 275.97 755.21 275.97 755.49 276.04 755.67 276.11",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M783.05 258.54C784.36 258.54 785.42 257.48 785.42 256.17 785.42 254.86 784.36 253.8 783.05 253.8 781.74 253.8 780.68 254.86 780.68 256.17 780.68 257.48 781.74 258.54 783.05 258.54Z",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M795.8 306.83H833.07",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M775.54 306.83H791.34",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M775.54 320.39H833.07",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M821.87 333.96H833.07",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M775.54 333.96H817.06",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M775.54 347.46H833.07",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M807.53 360.99H833.07",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M795.7 360.99H803.24",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M775.54 360.99H791.27",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1083.45 413.76H1011.97L989.11 436.62V413.76H975.45V348.73H1118.75V413.76H1090.35",
    fill: "#78c7e0",
    opacity: 1,
    strokeWidth: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1083.45 413.76H1011.97L989.11 436.62V413.76H975.45V348.73H1118.75V413.76H1090.35",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1040.82 370.31H1051.39",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M996.89 370.31H1035.86",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M996.89 381.25H1051.39",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M996.89 392.21H1035.86",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M513.5 436.66L589.08 436.66 613.25 463.38V436.66H627.69V360.67H476.17V436.66H506.2",
    fill: "#78c7e0",
    opacity: 1,
    strokeWidth: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.5 436.66L589.08 436.66 613.25 463.38V436.66H627.69V360.67H476.17V436.66H506.2",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.57 385.89H547.4",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.02 385.89H563.82",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.02 398.67H547.4",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.02 411.48H563.82",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M285.91 405.34V419.49",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.91 429.97V444.12",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.91 479.33V493.48",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.89 429.97V444.12",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.97 405.34V419.49",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.97 454.7V468.85",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.97 479.33V493.48",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.05 405.34V419.49",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.05 454.7V468.85",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.05 479.33V493.48",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.03 405.34V419.49",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.03 454.7V468.85",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.91 467.26C288.97 467.26 291.45 464.78 291.45 461.72 291.45 458.67 288.97 456.19 285.91 456.19 282.86 456.19 280.37 458.67 280.37 461.72 280.37 464.78 282.86 467.26 285.91 467.26Z",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.89 467.26C308.95 467.26 311.43 464.78 311.43 461.72 311.43 458.67 308.95 456.19 305.89 456.19 302.84 456.19 300.35 458.67 300.35 461.72 300.35 464.78 302.84 467.26 305.89 467.26Z",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.97 442.63C329.03 442.63 331.51 440.15 331.51 437.09 331.51 434.04 329.03 431.56 325.97 431.56 322.92 431.56 320.43 434.04 320.43 437.09 320.43 440.15 322.92 442.63 325.97 442.63Z",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.05 442.63C349.11 442.63 351.59 440.15 351.59 437.09 351.59 434.04 349.11 431.56 346.05 431.56 343 431.56 340.51 434.04 340.51 437.09 340.51 440.15 343 442.63 346.05 442.63Z",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.03 442.63C369.09 442.63 371.57 440.15 371.57 437.09 371.57 434.04 369.09 431.56 366.03 431.56 362.98 431.56 360.49 434.04 360.49 437.09 360.49 440.15 362.98 442.63 366.03 442.63Z",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.89 417.91C308.95 417.91 311.43 415.42 311.43 412.37 311.43 409.31 308.95 406.83 305.89 406.83 302.84 406.83 300.35 409.31 300.35 412.37 300.35 415.42 302.84 417.91 305.89 417.91Z",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.89 491.99C308.95 491.99 311.43 489.51 311.43 486.45 311.43 483.4 308.95 480.91 305.89 480.91 302.84 480.91 300.35 483.4 300.35 486.45 300.35 489.51 302.84 491.99 305.89 491.99Z",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.03 491.99C369.09 491.99 371.57 489.51 371.57 486.45 371.57 483.4 369.09 480.91 366.03 480.91 362.98 480.91 360.49 483.4 360.49 486.45 360.49 489.51 362.98 491.99 366.03 491.99Z",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 1,
    fill: "none"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHero);
export default __webpack_public_path__ + "static/media/hero.0469a85982f023a6f8840c70ce61ae8e.svg";
export { ForwardRef as ReactComponent };